import { UIRouterModule } from "@uirouter/angular";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { localize } from "@gtmhub/localization";
import { HomeWidgetService } from "@webapp/home/services/home-widget.service";
import { LocalizationModule } from "@webapp/localization/localization.module";
import { UiButtonModule } from "@webapp/ui/button/button.module";
import { UiCardModule } from "@webapp/ui/card/card.module";
import { BaseWidgetComponent } from "@webapp/ui/dashboard/components/base-widget.component";
import { UiIconModule } from "@webapp/ui/icon/icon.module";
import { UiToastService } from "@webapp/ui/toast/services/toast.service";

@Component({
  selector: "view-feed-widget",
  templateUrl: "./view-feed-widget.component.html",
  styleUrls: ["./view-feed-widget.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [UiButtonModule, UiCardModule, UiIconModule, UIRouterModule, LocalizationModule],
})
export class ViewFeedWidgetComponent extends BaseWidgetComponent {
  public get title(): string {
    return localize("stay_in_the_loop");
  }

  constructor(private homeWidgetService: HomeWidgetService, private toastService: UiToastService) {
    super();
  }

  public close(): void {
    this.homeWidgetService.removeWidget(this.widgetId);

    const message = localize("you_can_find_feed_in_navigation");
    this.toastService.success(message, {
      uiShouldTimeout: true,
      uiDuration: 5000,
      uiPrimaryCTA: localize("undo"),
      uiOnPrimaryAction: () => this.homeWidgetService.addWidget(this.widgetId),
    });
  }
}
